import Styles from './styles.module.scss';

import type { NotificationModel } from '../../model/types/notification.model';
import type { UserModel } from '@/features/Shared/users/model/types/users.model';

interface Props {
	notification: NotificationModel;
	users: Record<string, UserModel> | undefined;
}

export const DetailsRow = ({ notification, users }: Props) => {
	return (
		<div className={Styles.expandedRowContainer}>
			{notification.body && <span>{notification.body}</span>}
			<div>
				{notification.recipients && notification.recipients.length > 0 && (
					<div className={Styles.recipientsContainer}>
						{notification.recipients.map((recipientId) => (
							<div className={Styles.item} key={recipientId}>
								{`${users?.[recipientId]?.firstName} ${users?.[recipientId]?.lastName}`.trim() ||
									'N/A'}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};
